import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {Button, Form} from 'react-bootstrap';
import TextareaAutosize from 'react-autosize-textarea';
import {getLeadByID, gotAnsweredResponsible} from '../../redux/reduxActions/leadActions';
import {setObjectiveSelector, showToastError} from '../utils';

const GotAnswered = (props) => {
    const { selectedLead, responsible } = props;
    const [changeResponsible,setChangeResponsible] = useState(false);
    const [upWorChatLink, setUpWorChatLink] = useState('');
    const [comment, setComment] = useState();
    const [responsibleState, setResponsible] = useState('');
    // console.log(props.responsible);
    useEffect(() => {
        props.getLeadByID(props.match.params.id);
    }, []);
    const responsiblePerson = () => {
        const type = Object.entries(props.responsible)
            .find((el) => parseInt(el[0], 10) === selectedLead.responsible);
        if (!type) {
            return '-';
        }
        return type[1];
    };
    function gotAnsweredApply() {
        if(upWorChatLink){
            const isUpWorChatLink = upWorChatLink.match(/(http|https):\/\/([\w.]+\/?)\S*/);
            if(isUpWorChatLink) {
                props.gotAnsweredResponsible(selectedLead.id, {comment, responsible: responsibleState, upwork_chat_link: upWorChatLink }, props.history.push);
            } else{
                showToastError('Field  "UpWork Chat Link" is not a link');
                return;
            }
        } else {
            props.gotAnsweredResponsible(selectedLead.id, {comment, responsible: responsibleState}, props.history.push);
        }
    }
    return (
        <div>
            <div>
                <div className="lead__container" style={{ minHeight: 'auto' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', marginBottom: 10 }}>
                        <h3 style={{ color: '#383838', marginBottom: 0, height: 'min-content' }}>
                            Got_Answered.Lead Action
                        </h3>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-around',
                                width:'200px'
                            }}
                        >
                            <Button
                                onClick={() => window.history.back()}
                                size="sm"
                                id="apply-filter"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={() => { gotAnsweredApply();}}
                                size="sm"
                                id="apply-filter"
                            >
                                Apply
                            </Button>
                        </div>
                    </div>
                    <div
                        style={{
                            display:'flex',
                            flexWrap: 'wrap',
                            margin:'20px'
                        }}
                    >
                        <p>Do you want to change the responsible person ?</p>
                        <div
                            style={{
                                paddingTop:'3px',
                                paddingLeft:'20px',
                                paddingRight:'10px'
                            }}
                        >
                            <input onChange={() => setChangeResponsible(!changeResponsible)} type="checkbox" id="scales" name="scales"  />
                        </div>
                    </div>
                    <div className="lead__container__inner"
                         style={{
                             paddingTop:'3px',
                             paddingLeft:'20px',
                             paddingRight:'10px',
                             display: 'flex',
                             flexWrap: 'wrap'
                         }}
                    >
                        <p className="lead__title">
                            Responsible
                        </p>
                        <Form.Group style={{ width: '50%'}} controlId="formGridState">
                            <Form.Control disabled={!changeResponsible} as="select" onChange={({ target }) => setResponsible(target.value)}>
                                <option key="" value="">{responsiblePerson()}</option>
                                {setObjectiveSelector(responsible)}
                            </Form.Control>
                        </Form.Group>
                    </div>
                    <div className="lead__container__inner" 
                        style={{ marginBottom: '1rem',
                                paddingTop:'3px',
                                paddingLeft:'20px',
                                paddingRight:'10px' }}>
                        <p className="lead__title">
                            UpWork Chat Link:
                        </p>
                        <TextareaAutosize
                            onChange={(e) => setUpWorChatLink(e.target.value)}
                            className="lead__textarea lead__input"
                            rows={1}
                            style={{ borderBottomRightRadius: 0, borderTopRightRadius: 0, width:'80%' }}
                        />
                        <a
                            className="input-text-button"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Link
                        </a>
                    </div>
                    <TextareaAutosize
                        onChange={({ target: { value } }) => { setComment(value); }}
                        className="lead_input__first-message"
                        rows={3}
                        placeholder="..."
                    />
                </div>
            </div>
        </div>
    );
};
export default connect((state) => ({
    responsible: state.leadReducer.responsible,
    selectedLead: state.leadReducer.selectedLead,
}),{getLeadByID, gotAnsweredResponsible })(GotAnswered);